import { render } from "./ManageAccountContainers.vue?vue&type=template&id=789ecc2c&scoped=true"
import script from "./ManageAccountContainers.vue?vue&type=script&lang=js"
export * from "./ManageAccountContainers.vue?vue&type=script&lang=js"

import "./ManageAccountContainers.vue?vue&type=style&index=0&id=789ecc2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789ecc2c"]])

export default __exports__